import { render, staticRenderFns } from "./fully-paid-contract.vue?vue&type=template&id=3a87a9d9&scoped=true&"
import script from "./fully-paid-contract.vue?vue&type=script&lang=js&"
export * from "./fully-paid-contract.vue?vue&type=script&lang=js&"
import style0 from "./fully-paid-contract.vue?vue&type=style&index=0&id=3a87a9d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87a9d9",
  null
  
)

export default component.exports